// extracted by mini-css-extract-plugin
export default {"deviceWarning":"DeviceCheck_deviceWarning__KvrCW","content":"DeviceCheck_content__tMKEf","qrcode":"DeviceCheck_qrcode__fpQ2G"};